
import React, { useLayoutEffect } from 'react';
import { useApplicationConfiguration } from '../../configuration/ConfigurationContext';
import ControlledPageScroll from '../ControlledPageScroll';
import LanguageSelect from '../LanguageSelect';

import "./_PageTemplate.less";

interface PageTemplateProps {
    id?: string
};

export const PageTemplate: React.FC<PageTemplateProps> = ({ id, children }) => {
    const { showLanguageSelect } = useApplicationConfiguration()

    useLayoutEffect(() => {
        if (id) {
            document.body.id = id;
            return () => { document.body.id = ""; }
        }
    }, [id]);

    return (
        <ControlledPageScroll className="page-wrapper">
            <div className="page-container">
                {showLanguageSelect && (
                    <LanguageSelect />
                )}
                {children}
            </div>
        </ControlledPageScroll>
    );
}
